import { render } from "./BlogTabHome.vue?vue&type=template&id=7e70894a&scoped=true"
const script = {}

import "./BlogTabHome.vue?vue&type=style&index=0&id=7e70894a&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e70894a"]])

export default __exports__